import { Activity, HeartPulse, Gauge, Watch } from "lucide-react";

const SERVICIOS = [
  {
    icon: Activity,
    title: "Ecocardiografía Bidimensional",
    desc: "Imagen en tiempo real del corazón con tecnología Doppler para evaluar válvulas y función ventricular.",
  },
  {
    icon: HeartPulse,
    title: "Electrocardiograma & Prueba de Esfuerzo",
    desc: "Trazo eléctrico en reposo y bajo ejercicio supervisado para detectar arritmias e isquemia.",
  },
  {
    icon: Watch,
    title: "Monitoreo Holter 24h",
    desc: "Registro continuo del ritmo cardíaco durante un día completo en tu rutina normal.",
  },
  {
    icon: Gauge,
    title: "MAPA – Presión Arterial",
    desc: "Monitoreo Ambulatorio de Presión Arterial cada 20 minutos para diagnóstico preciso de hipertensión.",
  },
];

export const Servicios = () => {
  return (
    <section id="servicios" data-testid="servicios-section" className="py-20 md:py-28 bg-white relative">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-14">
          <div className="lg:col-span-7">
            <span className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--soft-red))] font-medium">
              · Conveniencia clínica ·
            </span>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--navy))] leading-[1.1]">
              Diagnóstico integral
              <br />
              en un <span className="italic font-light">solo lugar.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[hsl(var(--navy-soft))] text-base md:text-lg leading-relaxed">
              No pierdas tiempo trasladándote de un laboratorio a otro. En el consultorio contamos con la tecnología
              necesaria para realizar tus estudios el <strong className="text-[hsl(var(--navy))]">mismo día de tu consulta</strong>,
              con interpretación inmediata por el especialista.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICIOS.map((s, i) => (
            <article
              key={s.title}
              data-testid={`servicio-card-${i}`}
              className="group relative rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--cream))] p-6 transition-all hover:border-[hsl(var(--soft-red))] hover:shadow-warm hover:-translate-y-1 duration-300"
            >
              <div className="relative w-12 h-12 rounded-xl bg-[hsl(var(--navy))] text-[hsl(var(--cream))] grid place-items-center mb-5 group-hover:bg-[hsl(var(--soft-red))] transition-colors">
                <s.icon className="w-5 h-5" strokeWidth={1.6} />
              </div>
              <h3 className="font-serif-display text-xl text-[hsl(var(--navy))] mb-2 leading-snug">
                {s.title}
              </h3>
              <p className="text-sm text-[hsl(var(--navy-soft))] leading-relaxed">{s.desc}</p>

              <span className="absolute top-4 right-4 text-[10px] font-mono text-[hsl(var(--navy-soft))]/40">
                0{i + 1}
              </span>
            </article>
          ))}
        </div>

        <p className="mt-10 text-sm text-[hsl(var(--navy-soft))] text-center max-w-2xl mx-auto italic">
          También realizamos valoraciones preoperatorias completas, con resultados detallados entregados el mismo día.
        </p>
      </div>
    </section>
  );
};
